import React from 'react';
import { Link } from 'react-router-dom';
import './HomeComponents.css';

function RepairShopPromo({ repairShops }) {
  // Show at most 3 repair shops in the promotion section
  const displayShops = repairShops.slice(0, 3);
  
  return (
    <div className="repair-shop-promo">
      <div className="repair-shops-grid">
        {displayShops.map(shop => (
          <div key={shop.id} className="repair-shop-card">
            <div className="shop-image">
              <img src={shop.promoImage} alt={shop.name} />
            </div>
            <div className="shop-info">
              <h3 className="shop-name">{shop.name}</h3>
              <p className="shop-specialization">{shop.specialization}</p>
              <div className="shop-rating">
                <span className="rating-stars">
                  {'★'.repeat(Math.floor(shop.rating))}
                  {'☆'.repeat(5 - Math.floor(shop.rating))}
                </span>
                <span className="rating-value">{shop.rating.toFixed(1)}</span>
              </div>
              <p className="shop-blurb">{shop.shortBlurb}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="view-all-container">
        <Link to="/repair-shops" className="view-all-button">
          View All Repair Shops
        </Link>
      </div>
    </div>
  );
}

export default RepairShopPromo; 